import React from 'react';
import { MapPin, Phone, Star, ArrowDown } from 'lucide-react';
import { businessData } from '../data/mock';

const Hero = () => {
  const handleScrollToProducts = () => {
    const element = document.querySelector('#productos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-[var(--color-wine)] overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center pt-20 pb-16">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img
            src={businessData.logo}
            alt={`${businessData.name} Logo`}
            className="h-32 md:h-40 w-auto mx-auto rounded-lg shadow-2xl"
          />
        </div>

        {/* Rating Badge */}
        <div className="inline-flex items-center gap-2 bg-[var(--color-cream)] text-[var(--color-wine)] px-4 py-2 rounded-full mb-6 shadow-lg">
          <Star className="fill-[var(--color-gold)] text-[var(--color-gold)]" size={18} />
          <span className="font-semibold">{businessData.rating}</span>
          <span className="text-[var(--color-gray)]">({businessData.totalReviews} opiniones)</span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-[var(--color-cream)] mb-4 leading-tight">
          Tu vinoteca de confianza
          <br />
          <span className="text-[var(--color-gold)]">en Santa Fe</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-[var(--color-cream)]/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          Amplia selección de vinos, destilados y productos premium.
          Atención personalizada y asesoramiento experto.
        </p>

        {/* Location */}
        <div className="flex items-center justify-center gap-2 text-[var(--color-cream)]/70 mb-10">
          <MapPin size={18} />
          <span className="text-sm md:text-base">{businessData.address}</span>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href={businessData.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[var(--color-gold)] text-[var(--color-black)] px-8 py-4 rounded font-semibold text-lg transition-all hover:bg-[var(--color-gold-light)] hover:scale-105 hover:shadow-xl w-full sm:w-auto justify-center"
          >
            <Phone size={20} />
            Contactar por WhatsApp
          </a>
          <a
            href={businessData.googleMapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border-2 border-[var(--color-cream)] text-[var(--color-cream)] px-8 py-4 rounded font-semibold text-lg transition-all hover:bg-[var(--color-cream)] hover:text-[var(--color-wine)] w-full sm:w-auto justify-center"
          >
            <MapPin size={20} />
            Cómo llegar
          </a>
        </div>

        {/* Scroll indicator */}
        <button
          onClick={handleScrollToProducts}
          className="animate-bounce text-[var(--color-cream)]/60 hover:text-[var(--color-cream)] transition-colors"
          aria-label="Ver productos"
        >
          <ArrowDown size={32} />
        </button>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-auto"
          preserveAspectRatio="none"
        >
          <path
            d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
            fill="var(--color-cream)"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
